import { render, staticRenderFns } from "./ChatsPlaceholder.vue?vue&type=template&id=0ebf0078&scoped=true&"
import script from "./ChatsPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ChatsPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebf0078",
  null
  
)

export default component.exports